<template>
    <div class='main'>
        <div class='field'>
            <label class='label'>お子さまの学年・組・氏名</label>
            <div class='control'>
                <input v-model='name' class='input' type='text' placeholder='見本 太郎' required>
            </div>
        </div>
        <children-fields v-model='children' />
        <div class='field'>
            <label class='label'>保護者氏名（発送先のお名前）</label>
            <div class='control'>
                <input v-model='guardianName' class='input' type='text' placeholder='見本 花子' maxlength='100' autocomplete='name'>
            </div>
            <p class='help'>ゆうパケットなどの発送に使用します。プロフィール設定から後で登録・変更できます。</p>
        </div>
        <div class='field'>
            <label class='label'>メールアドレス</label>
            <div class='control has-icons-left has-icons-right'>
                <input v-model='email' class='input' type='email' placeholder='example@photoorder.jp' required>
                <span class='icon is-small is-left'>
                    <i class='fas fa-envelope'></i>
                </span>
            </div>
        </div>
        <div class='field'>
            <label class='label'>電話番号</label>
            <div class='control has-icons-left'>
                <input v-model='phone' class='input' type='tel' placeholder='ハイフンなし' required/>
                <span class='icon is-small is-left'>
                    <i class='fas fa-phone'></i>
                </span>
            </div>
        </div>
        <div class='field'>
            <label class='label'>郵便番号</label>
            <div class='control'>
                <input v-model='postal' class='input' type='text' placeholder='ハイフンなし' required/>
            </div>
        </div>
        <div class='field'>
            <label class='label'>住所</label>
            <div class='control'>
                <input v-model='address' class='input' type='text' placeholder='都道府県 市区町村 番地 建物名 部屋番号' required>
            </div>
        </div>
        <div class="control">
            <button class="button is-primary is-fullwidth is-medium" @click='send'>更新</button>
        </div>
    </div>
</template>

<script>
import ChildrenFields from '@/components/photobuy/ChildrenFields'

export default {
    name: 'Profile',
    props: [],
    components: { ChildrenFields },
    data () {
        return {
            name: '',
            guardianName: '',
            children: [],
            email: '',
            postal: '',
            address: '',
            phone: ''
        }
    },
    mounted () {
        const self = this

        self.axios.get(`${process.env.API_URL}/photobuy/profile`).then((res) => {
            self.name = res.data.name
            self.guardianName = res.data.guardianName || ''
            self.children = res.data.children || []
            self.email = res.data.email
            self.postal = res.data.postal
            self.address = res.data.address
            self.phone = res.data.phone
        }).catch((e) => {
            alert('サーバーに問題が発生しています')
        })
    },
    methods: {
        send () {
            const self = this

            self.axios.post(`${process.env.API_URL}/photobuy/profile`, {
                name: self.name,
                guardianName: self.guardianName,
                children: self.children.filter(child => child.name.trim()),
                email: self.email,
                address: self.address,
                postal: self.postal,
                phone: self.phone
            }).then((res) => {
                if (res.data.message === 'OK') {
                    self.children = res.data.children || []
                    self.$root.$emit('notification', 'is-primary', '更新が完了しました')
                } else {
                    self.$root.$emit('notification', 'is-danger', '更新に失敗しました')
                }
            }).catch((e) => {
                if (e.response && e.response.data && e.response.data.code === 'invalid_children') {
                    self.$root.$emit('notification', 'is-danger', 'お子さまの登録内容を確認してください（氏名は100文字以内、20人まで）')
                    return
                }
                alert('サーバーに問題が発生しています')
            })
        }
    }
}
</script>

<style scoped>

.main {
    width: 100%;
    max-width: 520px;
    padding-right: 30px;
}

.button {
    margin-top: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/Profile.vue